import {gql} from "@apollo/client";

export const QUERY_WATER_SYSTEM_STATUSES = gql`
  query GetWaterSystemStatuses($lifecyclePhases: [String!]!) {
        WaterSystemStatuses(where: {
            lifecyclePhase: {IN: $lifecyclePhases},
        }) {
          select {
            waterSystemId,
            waterSystemName,
            siteId,
            siteName,
            siteCountry,
            organizationId,
            organizationName,
            valveType,
            typeOfValve,
            isPaying,
            isTestUnit,
            valvesCount,
            pulseRatio,
            httpMode,
            httpModeCurrent,
            emnifyId,
            policyId,
            policyName,
            policyType,
            policyData,
            hwId,
            innerType,
            valveStatus,
            valveError,
            powerSource,
            systemInstallationDate,
            systemReplacementDate,
            cellNum,
            currentVersion,
            batStat,
            batteryVoltage,
            userFirstName,
            userLastName,
            lastKeepAlive,
            vmaxPulseCountIrr,
            vmaxPulseCount,
            irrigation,
            manualOverride,
            lifecyclePhase
      }
    }
  }
`;

export const QUERY_WATER_SYSTEM_STATUSES_NO_INPUT = gql`
  query GetWaterSystemStatuses {
        WaterSystemStatuses {
          select {
            waterSystemId,
            waterSystemName,
            siteId,
            siteName,
            siteCountry,
            organizationId,
            organizationName,
            valveType,
            typeOfValve,
            isPaying,
            isTestUnit,
            valvesCount,
            pulseRatio,
            httpMode,
            httpModeCurrent,
            emnifyId,
            policyId,
            policyName,
            policyType,
            policyData,
            hwId,
            innerType,
            valveStatus,
            valveError,
            powerSource,
            systemInstallationDate,
            systemReplacementDate,
            cellNum,
            currentVersion,
            batStat,
            batteryVoltage,
            userFirstName,
            userLastName,
            lastKeepAlive,
            vmaxPulseCountIrr,
            vmaxPulseCount,
            irrigation,
            manualOverride,
            lifecyclePhase
      }
    }
  }
`;

//production specific queries

export const QUERY_WATER_SYSTEM_STATUSES_PROD = gql`
  query GetWaterSystemStatuses($lifecyclePhases: [String!]!) {
        WaterSystemStatuses(where: {
            lifecyclePhase: {IN: $lifecyclePhases}
        }) {
          select {
            waterSystemId,
            waterSystemName,
            siteId,
            siteName,
            siteCountry,
            organizationId,
            organizationName,
            valveType,
            typeOfValve,
            isPaying,
            isTestUnit,
            valvesCount,
            pulseRatio,
            httpMode,
            httpModeCurrent,
            emnifyId,
            policyId,
            policyName,
            policyType,
            policyData,
            hwId,
            innerType,
            valveStatus,
            valveError,
            powerSource,
            systemInstallationDate,
            systemReplacementDate,
            cellNum,
            currentVersion,
            batStat,
            batteryVoltage,
            userFirstName,
            userLastName,
            lastKeepAlive,
            vmaxPulseCountIrr,
            vmaxPulseCount,
            irrigation,
            manualOverride,
            lifecyclePhase
      }
    }
  }
`;

export const QUERY_WATER_SYSTEM_STATUSES_NO_INPUT_PROD = gql`
  query GetWaterSystemStatuses {
        WaterSystemStatuses {
          select {
            waterSystemId,
            waterSystemName,
            siteId,
            siteName,
            siteCountry,
            organizationId,
            organizationName,
            valveType,
            typeOfValve,
            isPaying,
            isTestUnit,
            valvesCount,
            pulseRatio,
            httpMode,
            httpModeCurrent,
            emnifyId,
            policyId,
            policyName,
            policyType,
            policyData,
            hwId,
            innerType,
            valveStatus,
            valveError,
            powerSource,
            systemInstallationDate,
            systemReplacementDate,
            cellNum,
            currentVersion,
            batStat,
            batteryVoltage,
            userFirstName,
            userLastName,
            lastKeepAlive,
            vmaxPulseCountIrr,
            vmaxPulseCount,
            irrigation,
            manualOverride,
            lifecyclePhase
          }
        }
      }
`;
